module.exports = __webpack_public_path__ + "img/philosophers-of-technology-cover.3d7f1ab1.jpg";